import { useState, useEffect } from 'react';

const Routine = ({ challenge }) => {
  const [routinePages, setRoutinePages] = useState([]);

  useEffect(() => {
    if (
      challenge?.category !== 'HABIT' &&
      challenge?.category !== 'UPCOMING' &&
      challenge?.routines.length > 0
    ) {
      let copyRoutines = [...challenge.routines];

      const routineDays = challenge.routines.map(
        (routine) => routine.dayNumber
      );
      for (let day = 1; day <= challenge.days; day++) {
        if (!routineDays.includes(day)) {
          copyRoutines.push({
            dayNumber: day,
          });
        }
      }

      copyRoutines = copyRoutines.sort((a, b) => a.dayNumber - b.dayNumber);

      const pages = [];

      do {
        pages.push(copyRoutines.slice(0, 9));
        copyRoutines = copyRoutines.slice(9);
      } while (copyRoutines.length > 0);

      setRoutinePages(pages);
    }
  }, [challenge]);

  return routinePages.length > 0 ? (
    <div className='space-y-2'>
      <h2 className='uppercase font-bold text-sm text-white'>daily routines</h2>
      {challenge.category === 'CUSTOM' && (
        <li className='font-bold text-sm italic text-white'>Recommended</li>
      )}
      <div className='flex gap-4 snap-x overflow-x-scroll scrollbar-hidden snap-mandatory'>
        {routinePages.map((page, i) => (
          <div
            key={i}
            className={`snap-always snap-start shrink-0 ${
              routinePages.length > 1 ? 'w-11/12' : 'w-full'
            }`}
          >
            <div className='w-full'>
              <ul className='list-none rounded-xl px-4 py-3 bg-tertiary/20 space-y-2'>
                {page.map((routine, j) => (
                  <li key={j}>
                    <div className='flex items-center gap-2 text-white'>
                      <span className='text-xs'>Day {routine.dayNumber} </span>
                      <span className='font-bold text-sm'>
                        {routine.routine ? routine.routine.title : 'Rest Day'}
                      </span>
                      {routine.routine && (
                        <span className='text-xs opacity-40'>
                          ({routine.routine.groups.length} Workouts)
                        </span>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  ) : null;
};

export default Routine;
